<h1>Home</h1>
<nav>
  <h3>D3 Charts</h3>
  <a [routerLink]="['/basic-update']">Basic Update</a>
  <a [routerLink]="['/bar']">Bar Chart</a>
  <a [routerLink]="['/pie']">Pie Chart</a>
  <a [routerLink]="['/line']">Line Chart</a>
  <a [routerLink]="['/multi-line']">Multi Line Chart</a>
  <a [routerLink]="['/', 'stacked-area']">StackedArea</a>
  <a [routerLink]="['/', 'stacked-bars']">StackedBars</a>
</nav>
